import { useLD, LD_STATUSES, withLaunchDarkly } from '../components/LaunchDarkly';
import React, { FC, Fragment } from 'react';
import Loader from '../components/Loader';

export interface FeatureFlagGateProps {
  featureName: string;
  children: React.ReactNode;
  fallback: React.ReactNode;
}

const FeatureFlagGate: FC<FeatureFlagGateProps> = ({ featureName, children, fallback }) => {
  const [isFeatureToggleOn, status] = useLD(featureName);
  if (status === LD_STATUSES.FETCHING) {
    return <Loader />;
  }
  if (status === LD_STATUSES.FETCHED) {
    return <Fragment>{isFeatureToggleOn ? children : fallback}</Fragment>;
  }
};

export default withLaunchDarkly<FeatureFlagGateProps>(FeatureFlagGate);
